import { ExternalLinkIcon } from "lucide-react";

import { cn } from "../../utils/styling";

export function ExternalLinkText({
  href,
  text,
  className,
}: {
  href: string;
  text: string;
  className?: string;
}) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={cn(
        "flex flex-row gap-1 items-center text-foreground-secondary",
        className,
      )}
    >
      <ExternalLinkIcon className="w-3 h-3 stroke-2 text-foreground-secondary" />
      <p className="font-medium">{text}</p>
    </a>
  );
}
